import { useEffect, useState } from 'react';

export default function useGlobalToggle(ref, initialState = false) {
  const [isOpen, setOpen] = useState(initialState);

  useEffect(() => {
    // Only bind event handlers once open is true as a minor optimization
    if (!isOpen) return;

    const handleClickOutside = event => {
      if (ref.current != null && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isOpen]);

  return [isOpen, setOpen];
}
